import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

const latestprojectId = "whiteswan-vm-allocation";

export const getGCPAllRoles = async (latestTenant: string) => {

    let url = `${NGROK}/api/gcp/get-all-non-human-identities-roles?tenantName=${latestTenant}&projectId=${latestprojectId}`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};

export const getGCPAllIdentity = async (latestTenant: string) => {

    let url = `${NGROK}/api/gcp/non-human-identities?tenantName=${latestTenant}&projectId=${latestprojectId}`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};

export const getGCPAllActivity = async (latestTenant: string) => {

    let url = `${NGROK}/api/gcp/analytics/get-nhi-activity?tenantName=${latestTenant}&projectId=${latestprojectId}`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};

export const fetchGCPApiTokens = async (latestTenant: string) => {

    let url = `${NGROK}/api/gcp/tokens?tenantName=${latestTenant}&projectId=${latestprojectId}&timeRangeCode=7`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};


export const fetchGCPK8ServiceAccounts = async (latestTenant: string) => {

    let url = `${NGROK}/api/gcp/kubernetes/service-accounts?tenantName=${latestTenant}&projectId=${latestprojectId}&timeRangeCode=7`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};

export const fetchGCPK8ServiceSecrets = async (latestTenant: string) => {

    let url = `${NGROK}/api/gcp/kubernetes/secrets?tenantName=${latestTenant}&projectId=${latestprojectId}&timeRangeCode=7`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};

export const fetchGCPCloudSecrets = async (latestTenant: string) => {

    let url = `${NGROK}/api/gcp/secrets?tenantName=${latestTenant}&projectId=${latestprojectId}`

    const data = await apiClient({
        method: "GET",
        url: url
    });

    return data;
};

export interface CreateGCPAdminManagedSecretRequest {
    tenantName: string;
    projectId: string;
    name: string;
    secretValue: string;
}

export const createGCPAdminManagedSecret = async (request: CreateGCPAdminManagedSecretRequest) => {
    return apiClient({
        method: "POST",
        url: `${NGROK}/api/gcp/secrets/admin-managed`,
        data: request,
        sensitive: true,
    });
};
